import { Tab } from "@headlessui/react";
import { mdiEmailOutline, mdiPhone } from "@mdi/js";
import Icon from "@mdi/react";
import clsx from "clsx";

import Button from "components/Button";
import Header from "components/Header";
import MainLayout from "layouts/Main";
import HaulPayFAQ from "./HaulPayFAQ";
import HelpFAQ from "./HelpFAQ";
import styles from "./style.module.scss";

const tabTitle = ["Help FAQ", "HaulPay FAQ"];

export default function Help() {
  return (
    <MainLayout
      desktopTitle="Help"
      customHeader={<Header label="Help Request" headerIcon=" " isHideDesktop />}
      hideNavigation
      className={styles.helpContainer}>
      <div className={styles.info}>
        <span>Support tickets are handled the same day.</span>
        <span>Mon to Fri 8 AM - 5 PM PST.</span>
        <div className={styles.linkMethod}>
          <a href="tel:888-633-5558" className={styles.item}>
            <Button rounded iconButton>
              <Icon path={mdiPhone} />
            </Button>
            <span>(888) 633-5558</span>
          </a>
          <a href="mailto:support@haulpay.io" className={styles.item}>
            <Button rounded iconButton>
              <Icon path={mdiEmailOutline} />
            </Button>
            <span>support@haulpay.io</span>
          </a>
        </div>
      </div>

      <div className={styles.tabContainer}>
        <Tab.Group>
          <Tab.List className={styles.list}>
            {tabTitle.map((item) => (
              <Tab
                key={item}
                className={({ selected }) => clsx(styles.title, !selected ? "text-subtitle" : "")}>
                {item}
              </Tab>
            ))}
          </Tab.List>
          <Tab.Panels className="mt-3.5">
            <Tab.Panel>
              <HelpFAQ />
            </Tab.Panel>
            <Tab.Panel>
              <HaulPayFAQ />
            </Tab.Panel>
          </Tab.Panels>
        </Tab.Group>
      </div>
      <div>HaulPay App version {process.env.REACT_APP_REPOSITORY_DATE}</div>
    </MainLayout>
  );
}
